import React from "react";
import { site } from "@/data/site";

// "Book Now" CTA — opens the external reservation system in the SAME tab.
export default function BookButton({ className = "", variant = "golden", children, testid = "book-now-btn" }) {
  const base = variant === "outline" ? "btn-outline" : "btn-golden";
  return (
    <a
      href={site.bookingUrl}
      data-testid={testid}
      className={`${base} ${className}`}
    >
      {children || "BOOK NOW"}
    </a>
  );
}
